import * as ng from 'angular';
import { PanelHeaderData } from '../../../atomic-components/molecules/panels/panel-header/panel-header';

export class TemplateDomainJobDetailsController {
    public static $inject: string[] = ['$translate'];

    public pageHeaderData: PanelHeaderData;
    public job: any;

    constructor(private $translate: ng.translate.ITranslateService) {}

    public $onInit = () => {
        this.pageHeaderData = {
            backwardLink: 'domain.domains.jobs',
            backwardText: this.$translate.instant('TR_110119-d9061a_TR'),
            panelHeaderRoute: '',
            panelIcon: 'globe',
            panelTitle: this.$translate.instant('TR_110119-a4829a_TR', { jobName: this.job.displayName })
        };
    };
}

export class TemplateDomainJobDetailsComponent implements ng.IComponentOptions {
    public bindings = {
        job: '<'
    };
    public template = require('./domain-job-details-template.html');
    public controller = TemplateDomainJobDetailsController;
}
